import React, { Component } from 'react';
import Services from "../services/services";

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            version: 'Loading...',
            isTestVersion: null,
            isLoading: true,
            error: null,
        };
    }

    componentDidMount() {
        Services.getAppInfo((response) => {
            if (response?.status === 200) {
                this.setState({
                    version: response.data.version,
                    isTestVersion: response.data.isTestVersion,
                    isLoading: false,
                });
            } else {
                this.setState({
                    error: response.error,
                    isLoading: false,
                });
            }
        });
    }

    render() {
        const { version, isTestVersion, isLoading, error } = this.state;

        if (isLoading) {
            return <div>Loading app info...</div>;
        }

        if (error) {
            return <div>Error: {error}</div>;
        }

        return (
            <div>
                <h1>Hello!</h1>
                <p>Welcome to your Hunt intranet services!</p>
                <p>App Version: {version}</p>
                {isTestVersion && <p>This is the test version.</p>}
            </div>
        );
    }
}